import react from "react";
import FormControl from "@mui/material/FormControl";
import plusIcon from "../../Assests/plus-icon.svg";

interface AddRowButtonProps {
  isEditEnabled: boolean;
  handleAddRow: () => void;
}
const AddRowButton: React.FC<AddRowButtonProps> = ({
  isEditEnabled,
  handleAddRow,
}) => {
  return (
    <div className="filter-item">
      <FormControl fullWidth>
        <div
          className={`add-row-span ${isEditEnabled ? "" : "disabled"}`}
          onClick={isEditEnabled ? handleAddRow : undefined}
        >
          <img src={plusIcon} alt="" /> <span>Add&nbsp;Row</span>
        </div>
      </FormControl>
    </div>
  );
};

export default AddRowButton;
